import Select from "react-select";
import styled from "styled-components";
import { useHistory } from "react-router";
import { useEffect, useState } from "react";
import { allowSave, Option } from "../../store/helpers";
import { useLocation } from "react-router-dom";
import { RootState } from "../../store/rootReducer";
import { useDispatch, useSelector } from "react-redux";
import { getNegaraAsync } from "../../reducers/negara/negara.actions";
import * as partnerActions from "../../reducers/partner/partner.actions";
import { getJenisLembagaAsync } from "../../reducers/jenisLembaga/jenisLembaga.actions";
import { createPartnerAsync, initializeCreatePartner, updatePartnerAsync } from "../../reducers/partner/partner.actions";
import { fieldErrorMessage, fieldHasErrors } from "../../store/errorHandler";
import { PermissionMenuName } from "../../interfaces/UserRole";

export const PartnerUpdatePage = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const [isNew, setIsNew] = useState<boolean>(false);
  const [negaraOptions, setNegaraOptions] = useState<Option[]>([]);
  const errors = useSelector((state: RootState) => state.partner.error);
  const [jenisLembagaOptions, setJenisLembagaOptions] = useState<Option[]>([]);
  const listNegara = useSelector((state: RootState) => state.negara.listNegara);
  const partner = useSelector((state: RootState) => state.partner.selectedPartner);
  const isPartnerLoading = useSelector((state: RootState) => state.partner.isLoading);
  const redirectQueue = useSelector((state: RootState) => state.partner.redirectQueue);
  const isListNegaraLoading = useSelector((state: RootState) => state.negara.isLoading);
  const listJenisLembaga =  useSelector((state: RootState) => state.jenisLembaga.listJenisLembaga);
  const isListJenisLembagaLoading = useSelector((state: RootState) => state.jenisLembaga.isLoading);
  const role = useSelector((state: RootState) => state.authorization.systemAccess[PermissionMenuName.partner].ACCESS);

  const canSave = allowSave(role, 2);
  const isLoading = isPartnerLoading && isListNegaraLoading && isListJenisLembagaLoading;

  useEffect(() => {
    const paths = location.pathname.split("/");
    if (paths[2] === 'create') {
      setIsNew(true);
      dispatch(initializeCreatePartner());
    } else {
      setIsNew(false);
      const id = parseInt(paths[2]);
      if (id && !isNaN(id)) {
        dispatch(partnerActions.getDetailPartnerAsync.request({ id }));
      } else {
        history.push(`/partner/create`);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  useEffect(() => {
    const newOptions: Option[] = [];
    listNegara.forEach(item => {
      newOptions.push({
        value: item.id.toString(),
        label: item.name
      })
    });
    setNegaraOptions(newOptions);
  }, [listNegara])

  useEffect(() => {
    const newOptions: Option[] = [];
    listJenisLembaga.forEach(item => {
      newOptions.push({
        value: item.ID.toString(),
        label: item.CO_TYP_NAME
      })
    });
    setJenisLembagaOptions(newOptions);
  }, [listJenisLembaga])

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(getNegaraAsync.request());
    dispatch(getJenisLembagaAsync.request());
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  
  useEffect(() => {
    if (isNew) {
      dispatch(initializeCreatePartner());
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isNew])

  useEffect(() => {
    if (redirectQueue) {
      history.push(redirectQueue);
      dispatch(initializeCreatePartner());
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [redirectQueue])

  const getSelectedJenisLembagaOption = () => {
    if (!partner) return null;
    const selection = partner?.CO_TYP_DETAIL;
    return { value: selection?.ID.toString(), label: selection?.CO_TYP_NAME };
  }

  const onChangeName = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(partnerActions.updateName(e.target.value));
  }

  const onChangeAddress = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(partnerActions.updateAddress(e.target.value));
  }

  const onChangeWebsite = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(partnerActions.updateWebsite(e.target.value));
  }

  const onChangePhone = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(partnerActions.updatePhone(e.target.value));
  }

  const onChangeCity = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(partnerActions.updateCity(e.target.value));
  }

  const onChangePostCode = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(partnerActions.updatePostCode(e.target.value));
  }

  const onChangePicName = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(partnerActions.updatePicName(e.target.value));
  }

  const onChangePicEmail = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(partnerActions.updatePicEmail(e.target.value));
  }

  const onChangePicPhone = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(partnerActions.updatePicPhone(e.target.value));
  }

  const onChangePicPosition = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(partnerActions.updatePicPosition(e.target.value));
  }

  const onChangePicDepartment = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(partnerActions.updatePicDepartment(e.target.value));
  }

   const getSelectedNegaraOption = () => {
    if (!partner) return null;
    const selection = partner?.CO_NEGARA_DETAIL;
    return { value: selection?.id.toString(), label: selection?.name };
  }

  const onChangeCountry = (e: Option | null) => {
    if (!e) return;
    const newNegara = listNegara.find(search => search.id === e.value);
    if (newNegara) { dispatch(partnerActions.updateCountry(e.value, newNegara)); }
  }

  const onChangeType = (e: Option | null) => {
    if (!e) return;
    const id = parseInt(e.value);
    if (isNaN(id)) return;
    const newJenisLembaga = listJenisLembaga.find(search => search.ID === id);
    if (newJenisLembaga) { dispatch(partnerActions.updateType(id, newJenisLembaga)); }
  }

  const save = () => {
    if (!partner) return;
    if (isNew) {
      dispatch(createPartnerAsync.request(partner));
    } else {
      dispatch(updatePartnerAsync.request(partner));
    }
  }

  return (
    <PartnerUpdatePageWrapper>
      <section className="content">
        <div className="row">
          <div className="col-lg-4">
            <div className="box">
              <div className="box-header with-border">
                <h3 className="box-title">Detail Partner</h3>
                <div className="box-tools">
                  <button
                    className="btn btn-primary"
                    style={{marginRight: '4px'}}
                    onClick={() => history.push('/partner')}
                  >
                    kembali
                  </button>
                  <button
                    className="btn btn-primary"
                    disabled={isLoading || !canSave}
                    onClick={save}
                  >
                    Simpan
                  </button>
                </div>
              </div>
              <div className="box-body">
                
                <div className={`form-group ${fieldHasErrors('CO_NAME', errors) ? 'has-error' : ''}`}>
                  <label>Nama Lembaga <span className="text-red"><b>*</b></span></label>
                  <input
                    type="text"
                    onChange={onChangeName}
                    className='form-control'
                    disabled={isLoading || !canSave}
                    defaultValue={partner?.CO_NAME}
                    style={{ display: 'block', width: '100%' }}
                  />
                  <span className="help-block">{ fieldErrorMessage('CO_NAME', errors) }</span>
                </div>
                
                <div className={`form-group ${fieldHasErrors('CO_ALAMAT', errors) ? 'has-error' : ''}`}>
                  <label>Alamat <span className="text-red"><b>*</b></span></label>
                  <input
                    type="text"
                    className='form-control'
                    onChange={onChangeAddress}
                    disabled={isLoading || !canSave}
                    defaultValue={partner?.CO_ALAMAT}
                    style={{ display: 'block', width: '100%' }}
                  />
                  <span className="help-block">{ fieldErrorMessage('CO_ALAMAT', errors) }</span>
                </div>
                
                <div className={`form-group ${fieldHasErrors('CO_WEB', errors) ? 'has-error' : ''}`}>
                  <label>Website <span className="text-red"><b>*</b></span></label>
                  <input
                    type="text"
                    className='form-control'
                    onChange={onChangeWebsite}
                    disabled={isLoading || !canSave}
                    defaultValue={partner?.CO_WEB}
                    style={{ display: 'block', width: '100%' }}
                  />
                  <span className="help-block">{ fieldErrorMessage('CO_WEB', errors) }</span>
                </div>
                
                <div className={`form-group ${fieldHasErrors('CO_TELP', errors) ? 'has-error' : ''}`}>
                  <label>Telepon</label>
                  <input
                    type="text"
                    className='form-control'
                    onChange={onChangePhone}
                    disabled={isLoading || !canSave}
                    defaultValue={partner?.CO_TELP}
                    style={{ display: 'block', width: '100%' }}
                  />
                  <span className="help-block">{ fieldErrorMessage('CO_TELP', errors) }</span>
                </div>
                
                <div className={`form-group ${fieldHasErrors('CO_KOTA', errors) ? 'has-error' : ''}`}>
                  <label>Kota <span className="text-red"><b>*</b></span></label>
                  <input
                    type="text"
                    className='form-control'
                    onChange={onChangeCity}
                    disabled={isLoading || !canSave}
                    defaultValue={partner?.CO_KOTA}
                    style={{ display: 'block', width: '100%' }}
                  />
                  <span className="help-block">{ fieldErrorMessage('CO_KOTA', errors) }</span>
                </div>
                
                <div className={`form-group ${fieldHasErrors('CO_KODEPOS', errors) ? 'has-error' : ''}`}>
                  <label>Kode Pos <span className="text-red"><b>*</b></span></label>
                  <input
                    type="text"
                    className='form-control'
                    onChange={onChangePostCode}
                    disabled={isLoading || !canSave}
                    defaultValue={partner?.CO_KODEPOS}
                    style={{ display: 'block', width: '100%' }}
                  />
                  <span className="help-block">{ fieldErrorMessage('CO_KODEPOS', errors) }</span>
                </div>

                <div className={`form-group ${fieldHasErrors('CO_NEGARA_ID', errors) ? 'has-error' : ''}`}>
                  <label>Negara <span className="text-red"><b>*</b></span></label>
                  <Select 
                    isDisabled={isLoading || !canSave}
                    options={negaraOptions}
                    onChange={onChangeCountry}
                    value={getSelectedNegaraOption()}
                  />
                  <span className="help-block">{ fieldErrorMessage('CO_NEGARA_ID', errors) }</span>
                </div>
                
                <div className={`form-group ${fieldHasErrors('CO_TYP_ID', errors) ? 'has-error' : ''}`}>
                  <label>Jenis Lembaga <span className="text-red"><b>*</b></span></label>
                  <Select 
                    isDisabled={isLoading || !canSave}
                    options={jenisLembagaOptions}
                    onChange={onChangeType}
                    value={getSelectedJenisLembagaOption()}
                  />
                  <span className="help-block">{ fieldErrorMessage('CO_TYP_ID', errors) }</span>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-4">
            <div className="box">
              <div className="box-header with-border">
                <h3 className="box-title">Detail PIC</h3>
                <div className="box-tools">
                  
                </div>
              </div>
              <div className="box-body">
                <div className={`form-group ${fieldHasErrors('CO_PIC_NAME', errors) ? 'has-error' : ''}`}>
                  <label>Nama PIC <span className="text-red"><b>*</b></span></label>
                  <input
                    type="text"
                    className='form-control'
                    onChange={onChangePicName}
                    disabled={isLoading || !canSave}
                    defaultValue={partner?.CO_PIC_NAME}
                    style={{ display: 'block', width: '100%' }}
                  />
                  <span className="help-block">{ fieldErrorMessage('CO_PIC_NAME', errors) }</span>
                </div>
                
                <div className={`form-group ${fieldHasErrors('CO_PIC_EMAIL', errors) ? 'has-error' : ''}`}>
                  <label>Email PIC <span className="text-red"><b>*</b></span></label>
                  <input
                    type="text"
                    className='form-control'
                    onChange={onChangePicEmail}
                    disabled={isLoading || !canSave}
                    defaultValue={partner?.CO_PIC_EMAIL}
                    style={{ display: 'block', width: '100%' }}
                  />
                  <span className="help-block">{ fieldErrorMessage('CO_PIC_EMAIL', errors) }</span>
                </div>
                
                <div className={`form-group ${fieldHasErrors('CO_PIC_PHONE', errors) ? 'has-error' : ''}`}>
                  <label>Nomor Telepon PIC</label>
                  <input
                    type="text"
                    className='form-control'
                    onChange={onChangePicPhone}
                    disabled={isLoading || !canSave}
                    defaultValue={partner?.CO_PIC_PHONE}
                    style={{ display: 'block', width: '100%' }}
                  />
                  <span className="help-block">{ fieldErrorMessage('CO_PIC_PHONE', errors) }</span>
                </div>
                
                <div className={`form-group ${fieldHasErrors('CO_PIC_JOB_TITLE', errors) ? 'has-error' : ''}`}>
                  <label>Jabatan PIC <span className="text-red"><b>*</b></span></label>
                  <input
                    type="text"
                    className='form-control'
                    onChange={onChangePicPosition}
                    disabled={isLoading || !canSave}
                    defaultValue={partner?.CO_PIC_JOB_TITLE}
                    style={{ display: 'block', width: '100%' }}
                  />
                  <span className="help-block">{ fieldErrorMessage('CO_PIC_JOB_TITLE', errors) }</span>
                </div>
                
                <div className={`form-group ${fieldHasErrors('CO_PIC_DEPT', errors) ? 'has-error' : ''}`}>
                  <label>Departemen PIC <span className="text-red"><b>*</b></span></label>
                  <input
                    type="text"
                    className='form-control'
                    onChange={onChangePicDepartment}
                    disabled={isLoading || !canSave}
                    defaultValue={partner?.CO_PIC_DEPT}
                    style={{ display: 'block', width: '100%' }}
                  />
                  <span className="help-block">{ fieldErrorMessage('CO_PIC_DEPT', errors) }</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </PartnerUpdatePageWrapper>
  );
}

const PartnerUpdatePageWrapper = styled.div``;